import React from 'react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch, renderComponentsSwitch} from '../../../utils/contentRenderer'

/**
 * GDISizeGuidesBlock
 *
 * Renders the content area of a size-guide block. Used both:
 *  1. On the dedicated size-guide CMS page (inside GDITabsLayoutBlock tabs), and
 *  2. On PDP via SizeChartDrawer (matched by CategoryId to product.c_sizeChartWeb).
 *
 * CMS shape:
 *   CategoryId                 — slug matching product.c_sizeChartWeb, or a
 *                                comma-separated list of them (used by PDP only)
 *   GDISizeGuidesBlockContent  — content area items (tables, text blocks, images…)
 *
 * Optimizely Graph's MaxExpansionDepth cap truncates this block when it sits deep
 * in the page query; that is repaired server-side before caching, in
 * utils/optimizely-depth-repair.js. The depth-cap skip below stays as a guard for
 * anything that still arrives unresolved.
 */
const GDISizeGuidesBlock = ({GDISizeGuidesBlockContent}) => {
    const items = GDISizeGuidesBlockContent ?? []
    if (items.length === 0) return null

    return (
        <>
            {items.map((item, i) => {
                const exp = item?.ContentLink?.Expanded
                // Skip null/undefined AND depth-cap entries (truthy object with no __typename).
                if (!exp || !exp.__typename) return null
                return (
                    <React.Fragment key={i}>
                        {renderLayoutsSwitch(exp) || renderComponentsSwitch(exp)}
                    </React.Fragment>
                )
            })}
        </>
    )
}

GDISizeGuidesBlock.propTypes = {
    CategoryId: PropTypes.string,
    GDISizeGuidesBlockContent: PropTypes.arrayOf(PropTypes.object)
}

export default GDISizeGuidesBlock
